export default class { 
  init() {
    const triggers = document.querySelectorAll('[data-gtm-resource]');

    for (let i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', (e) => {
        console.log(e.target);
        window.dataLayer.push({
          'event': 'resource-click',
          'name': e.target.getAttribute('data-gtm-resource')
        });
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/classes/resource-events.class.js